import { Link } from 'react-router-dom';
import { LEGAL, SUPPORT_MAILTO } from '../../config/legal';
import { PRIVACY_INTRO, PRIVACY_SECTIONS } from '../../config/privacy';
import usePageMeta from '../../hooks/use-page-meta';
import LegalDocument from './LegalDocument';

export default function Privacy() {
  usePageMeta({
    title: 'Privacy Policy',
    description: `Privacy Policy for ${LEGAL.productName}: what we collect, how we use it, and your choices.`,
    path: '/privacy',
  });

  return (
    <LegalDocument
      title="Privacy Policy"
      effectiveDate={LEGAL.effectiveDate}
      intro={PRIVACY_INTRO}
      sections={PRIVACY_SECTIONS}
      footer={
        <>
          See also our{' '}
          <Link
            className="text-bk-gold underline-offset-2 hover:underline"
            to="/terms"
          >
            Terms of Service
          </Link>
          . Questions?{' '}
          <a
            className="text-bk-gold underline-offset-2 hover:underline"
            href={SUPPORT_MAILTO}
          >
            {LEGAL.supportEmail}
          </a>
          .
        </>
      }
    />
  );
}
